import React from 'react';

function BentoCard({ children, className = '', onClick }) {
  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-2xl p-5 shadow-bento hover:shadow-bento-hover transition-shadow duration-200 ease-premium ${
        onClick ? 'cursor-pointer' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
}

export default BentoCard;
